"use client";
import { useState } from "react";
import { AttendanceStatus } from "@prisma/client";
import { toastHandler } from "../ToastHandler";
import { Button } from "../v3/themed/Button";
import { updateAttendeeStatus } from "./actions/change-attendee-status";
import { RSVPWrapperCustomization } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";

const UnRSVPButtons = ({
    eventId,
    onUpdateStatus,
    customization,
}: {
    eventId?: string;
    onUpdateStatus?: (status: AttendanceStatus) => Promise<void>;
    customization?: RSVPWrapperCustomization;
}) => {
    const [isLoading, setIsLoading] = useState(false);
    if (!eventId) return null;

    const handleStatusChange = async (status: AttendanceStatus) => {
        setIsLoading(true);
        await toastHandler({
            loadingMessage: "Updating status",
            successMessage: "Updated!",
            operation: async () => {
                const result = await updateAttendeeStatus(eventId, status);
                await onUpdateStatus?.(result.status);
            },
            onSettled: () => {
                setIsLoading(false);
            },
        });
    };

    return (
        <div className="flex flex-row gap-2">
            <Button
                className={cn(
                    "flex-1 justify-center whitespace-nowrap shadow-none disabled:bg-v3-N-500 disabled:text-v3-N-300",
                    customization?.linkClassName,
                )}
                variant="primaryLink"
                disabled={isLoading}
                onClick={async () => {
                    await handleStatusChange("MAYBE");
                }}
            >
                🤔 Maybe
            </Button>
            <Button
                className={cn(
                    "flex-1 justify-center whitespace-nowrap shadow-none disabled:bg-v3-N-500 disabled:text-v3-N-300",
                    customization?.linkClassName,
                )}
                variant="primaryLink"
                disabled={isLoading}
                onClick={async () => {
                    await handleStatusChange("NOT_ATTENDING");
                }}
            >
                😢 Can't go
            </Button>
        </div>
    );
};

export default UnRSVPButtons;
